import { Card, Col, Form, Input, Label, Row } from "reactstrap";
import { Button } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import Select from "../../Common/AppSelect";
import { isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import {
  createTaskCrmIT,
  createTaskCrmITSuccess,
  createTaskTemplate,
  createTaskTemplateSuccess,
  getTaskCrmIT,
  getTaskPriorityList,
  getTasksCrmITList,
  getTaskStatusListCrmIT,
  getTaskTemplateList,
  getTaskTypeList,
  searchTaskList,
  updateTaskCrmIT,
  updateTaskCrmITSuccess,
  updateTaskTemplate,
  updateTaskTemplateSuccess,
} from "../../../store/tasksCrmIT/action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { AppDateTimePicker } from "../../Common/AppDateTimePicker";
import {
  getSingleJobDetailsForTimer,
  getSingleJobRecentActivityList,
} from "../../../store/singleJob/action";
import RichTextEditor from "../../RichTextEditor";
import {
  getStaffList,
  getOrganisationDepartmentList,
} from "../../../store/staff/action";
import filterActiveStaff from "../../Common/staffActive";
import {
  getCustomersListData,
  getSingleCustomerSiteLocationListData,
} from "../../../store/customers/action";
import { getJobsData } from "../../../store/jobsList/actions";
// Task 24610 - starting the timer on the task you just raised.
import {
  timeEntryReduxStateDataSuccess,
  timerIsRunning,
  actionEventFiredSuccess,
} from "../../../store/timeEntries/action";
import { toast } from "react-toastify";
import {
  flatPickerConvertRawToFormatedDateAndTime,
  timeFormatDateAndTime,
} from "../../Common/HandleDateTime";
import JobCreateEdit from "../JobCreateEdit";
import "../popupComponents.styles.scss";

import { checkListTemplateListActive } from "../../../store/checkList/action";
import { listVehicles } from "../../../store/vehicle/action";
import {
  isSystemModuleActive,
  SYSTEM_MODULE_CODES,
} from "../../../helpers/functions/systemModules";
import { sortTaskStatuses } from "../../../helpers/functions/taskStatusOrder";
import SearchAddress from "./searchAddress";
import { getAllOpportunitiesList } from "../../../store/opportunities/action";
import { contactPersonList } from "../../../store/people/action";
import { CustomSelect } from "../../Common/CustomSelect";
import { getLocationSummaryText } from "../../Common/LocationSummaryLine";
import AppModal from "../../Common/AppModal";
export const handleCalculateHowManyMinutesBetweenTwoDates = (date1, date2) => {
  const diffInMs = Math.abs(date2 - date1);
  return Math.floor(diffInMs / (1000 * 60));
};
const handleIncreaseDecraeseDurationByHourOrByMinutes = (
  hours,
  minutes,
  singleTaskCreateUpdate,
  setSingleTaskCreateUpdate
) => {
  //first we check get current duration hours and minutes
  let currentHours = Math.floor(singleTaskCreateUpdate.DurationMins / 60);
  let currentMinutes = singleTaskCreateUpdate.DurationMins % 60;
  // check first if its a valid substraction from current duration

  //if valid do the math and update duration and EndDateTime
  let newDuration = (currentHours - hours) * 60 + (currentMinutes - minutes);
  // Duration drives EndDateTime from StartDateTime — but only if Start is a
  // valid date. Without this guard an empty/invalid Start yields
  // "NaN-NaN-NaN NaN:NaN:NaN", which blanks the End picker and would be sent
  // to the server.
  const startDate = new Date(singleTaskCreateUpdate.StartDateTime);
  if (isNaN(startDate.getTime())) {
    toast.error("Please select a Start date/time first.");
    return;
  }
  setSingleTaskCreateUpdate({
    ...singleTaskCreateUpdate,
    DurationMins: newDuration,
    EndDateTime: timeFormatDateAndTime(
      new Date(startDate.setMinutes(startDate.getMinutes() + newDuration))
    ),
  });
};

const handleOnChangeHoursInput = (
  e,
  singleTaskCreateUpdate,
  setSingleTaskCreateUpdate
) => {
  // first we check if its a valid number
  if (e.target.value > 23 || e.target.value < 0) {
    toast.error("Please enter a valid number 0-23");
    return;
  }
  // if valid do the math and update duration and EndDateTime
  let newDuration =
    e.target.value * 60 + (singleTaskCreateUpdate.DurationMins % 60);
  const startDate = new Date(singleTaskCreateUpdate.StartDateTime);
  if (isNaN(startDate.getTime())) {
    toast.error("Please select a Start date/time first.");
    return;
  }
  setSingleTaskCreateUpdate({
    ...singleTaskCreateUpdate,
    DurationMins: newDuration,
    EndDateTime: timeFormatDateAndTime(
      new Date(startDate.setMinutes(startDate.getMinutes() + newDuration))
    ),
  });
};

const handleOnChangeMinutesInput = (
  e,
  singleTaskCreateUpdate,
  setSingleTaskCreateUpdate
) => {
  // first we check if its a valid number
  if (e.target.value > 59 || e.target.value < 0) {
    toast.error("Please enter a valid number 0-59");
    return;
  }
  // if valid do the math and update duration and EndDateTime
  let newDuration =
    Math.floor(singleTaskCreateUpdate.DurationMins / 60) * 60 + +e.target.value;
  const startDate = new Date(singleTaskCreateUpdate.StartDateTime);
  if (isNaN(startDate.getTime())) {
    toast.error("Please select a Start date/time first.");
    return;
  }
  setSingleTaskCreateUpdate({
    ...singleTaskCreateUpdate,
    DurationMins: newDuration,
    EndDateTime: timeFormatDateAndTime(
      new Date(startDate.setMinutes(startDate.getMinutes() + newDuration))
    ),
  });
};
const handleAddNewItemToCheckList = (
  tempChecklistSelection,
  singleTaskCreateUpdate,
  setSingleTaskCreateUpdate
) => {
  if (isEmpty(tempChecklistSelection)) {
    toast.error("Please Select a Checklist Template");
    return;
  }
  // add selected checklist to taskchecklisttemplate_list with new Lid as local id first find if it exist if its not then start with 1 if it dose get max id then + 1
  let newId = 1;
  if (!isEmpty(singleTaskCreateUpdate?.taskchecklisttemplate_list)) {
    newId =
      Math.max(
        ...((singleTaskCreateUpdate?.taskchecklisttemplate_list
          ? singleTaskCreateUpdate?.taskchecklisttemplate_list?.map(
              (item) => item?.Lid
            )
          : [0]) ?? 0)
      ) + 1;
  }
  setSingleTaskCreateUpdate({
    ...singleTaskCreateUpdate,
    taskchecklisttemplate_list: [
      ...(singleTaskCreateUpdate.taskchecklisttemplate_list
        ? singleTaskCreateUpdate.taskchecklisttemplate_list
        : []),
      {
        Lid: newId,
        TaskChecklistTemplate_Title: tempChecklistSelection?.label,
        TaskChecklistTemplate_Id: tempChecklistSelection?.id,
        isEdit: true,
      },
    ],
  });
};
export default function CreateEditTaskPopUp({
  modalTask,
  setModalTask,
  toggleTask,
  isEdit,
  Customer_Id = "",
  Job_Id = "",
  Single_Customer,
  Single_Job,
  Single_Recent_Activity,
  Staff_Id = "",
  stopStartTimer,
  SingleTaskCrmIT,
  createNewTaskWithDueDate,
  selectedWekStartAndEnd,
  Opportunity_Id = "",
  taskTemplate = false,
  TaskStatus_Id = "",
  singleEmail,
  page,
}) {
  const dispatch = useDispatch();
  // Task 24610 - tick this and the timer starts on the task as soon as it is
  // created, instead of raising the task, finding it in the list and starting
  // the timer by hand. The job and title are captured at submit time because
  // the form is cleared before the create response comes back.
  const [startTimerOnSave, setStartTimerOnSave] = useState(false);
  const startTimerContextRef = useRef(null);

  const { timerEntryData, timerRunning } = useSelector((state) => ({
    timerEntryData: state.TimeEntries?.timeEntryData?.timeentry_data,
    timerRunning:
      state.TimeEntries?.timeEntryData?.timeentry_data?.timerIsRunning,
  }));

  const [createTaskInProgress, setCreateTaskInProgress] = useState(false);
  const [isClearEditor, setIsClearEditor] = useState(false);
  const [localToggle, setLocalToggle] = useState(false);
  // get filters data from state
  const { customersList } = useSelector((state) => ({
    customersList: state.Customers?.customersDataList?.customer_list,
  }));
  const { singleCustomerSiteLocationListAPI } = useSelector((state) => ({
    singleCustomerSiteLocationListAPI:
      state.Customers.singleCustomerSiteLocationList?.customersitelocation_list,
  }));

  // get staff members data from state
  const { staffData } = useSelector((state) => ({
    staffData: state.Staff.staffList?.staff_list,
  }));

  // get organisation departments (teams) from state
  const organisationDepartmentList = useSelector(
    (state) =>
      state.Staff.organisationDepartmentList?.organisationdepartment_list
  );

  const { tasksCrmITList, taskCrmIT, tasksCrmITStatusList } = useSelector(
    (state) => ({
      tasksCrmITList: state.TasksCrmIt.tasksCrmITList?.task_list,
      taskCrmIT: state.TasksCrmIt.taskCrmIT?.task_data,
      tasksCrmITStatusList:
        state.TasksCrmIt.taskStatusListCrmIT?.taskstatus_list,
    })
  );
  const { taskTemplateData, taskTemplateDataLoading } = useSelector(
    (state) => ({
      taskTemplateData: state.TasksCrmIt.taskTemplateData?.tasktemplate_data,
      taskTemplateDataLoading: state.TasksCrmIt.taskTemplateDataLoading,
    })
  );
  const { checklistTemplateActiveAPI } = useSelector((state) => ({
    checklistTemplateActiveAPI:
      state.Checklist.checklistTemplateActive?.taskchecklisttemplate_list,
  }));
  const [popUpUpdateTask, setPopUpUpdateTask] = useState(false);
  const [diarySlotEnabled, setDiarySlotEnabled] = useState(false);
  const [diarySlot, setDiarySlot] = useState({
    StartDateTime: "",
    EndDateTime: "",
    Notes: "",
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressLine4: "",
    AddressCity: "",
    AddressCounty: "",
    AddressPostcode: "",
  });

  const { taskPriorityList, taskTypeList } = useSelector((state) => ({
    taskPriorityList: state.TasksCrmIt.taskPriorityList?.taskpriority_list,
    taskTypeList: state.TasksCrmIt.taskTypeList?.tasktype_list,
  }));

  const { jobsListApi } = useSelector((state) => ({
    jobsListApi: state.Jobs.jobsData?.job_list,
  }));
  const { vehicleListAPI } = useSelector((state) => ({
    vehicleListAPI: state.Vehicle.vehicleList?.vehicle_list,
  }));

  const { Opportunities_List } = useSelector((state) => ({
    Opportunities_List:
      state.Opportunities.getAllOpportunitiesList?.opportunity_list,
  }));

  const [jobsList, setJobsList] = useState([]);
  const seed = createNewTaskWithDueDate
    ? new Date(createNewTaskWithDueDate)
    : null;
  console.log("TaskStatus_Id", TaskStatus_Id);

  const getInitialTaskData = () => {
    const seed = createNewTaskWithDueDate
      ? new Date(createNewTaskWithDueDate)
      : null;

    return {
      Id: "",
      Title: singleEmail?.Subject ?? "",
      Description: "",
      Customer_Id: Customer_Id,
      ContactPerson_Id: "",
      Staff_Id: Staff_Id,
      OrganisationDepartment_Id: "",
      Project: "",
      TaskType_Id: "",
      TaskPriority_Id: "",
      TaskStatus_Id: TaskStatus_Id,
      Job_Id: Job_Id,
      DueDateTime: seed ? timeFormatDateAndTime(seed) : "",
      StartDateTime: seed ? timeFormatDateAndTime(seed) : "",
      EndDateTime: seed
        ? timeFormatDateAndTime(new Date(seed.getTime() + 60 * 60000))
        : "",
      DurationMins: seed
        ? handleCalculateHowManyMinutesBetweenTwoDates(
            new Date(seed),
            new Date(seed.getTime() + 60 * 60000)
          )
        : 60,
      FlagAllDay: "0",
      taskchecklisttemplate_list: [],
      Vehicle_Id: "",
      // Task location (3-way): 0=inherit from linked Job, 1=site location, 2=manual address
      TaskLocationMode: 0,
      CustomerSiteLocation_Id: "",
      AddressLine1: "",
      AddressLine2: "",
      AddressLine3: "",
      AddressLine4: "",
      AddressCity: "",
      AddressCounty: "",
      AddressPostCode: "",
      AddressCountry: "",
      LocationLatitude: "",
      LocationLongitude: "",
      LocationAddressLine1: "",
      LocationAddressLine2: "",
      LocationAddressLine3: "",
      LocationAddressLine4: "",
      LocationAddressCity: "",
      LocationAddressCounty: "",
      LocationAddressPostcode: "",
      LocationAddressCountry: "",
      Opportunity_Id: Opportunity_Id,
      taskTemplate: taskTemplate,
      DueDateTimeAddYears: "",
      DueDateTimeAddMonths: "",
      DueDateTimeAddDays: "",
      DueDateTimeAddHours: "",
      DueDateTimeAddMins: "",
      emailinbound_list: [
        {
          Id: singleEmail?.Id ?? "",
        },
      ],
    };
  };
  const initialTaskData = {
    Id: "",
    Title: singleEmail?.Subject ?? "",
    Description: "",
    Customer_Id: Customer_Id,
    ContactPerson_Id: "",
    Staff_Id: Staff_Id,
    OrganisationDepartment_Id: "",
    Project: "",
    TaskType_Id: "",
    TaskPriority_Id: "",
    TaskStatus_Id: TaskStatus_Id,
    Job_Id: Job_Id,
    DueDateTime: seed ? timeFormatDateAndTime(seed) : "",
    StartDateTime: seed ? timeFormatDateAndTime(seed) : "",
    EndDateTime: seed
      ? timeFormatDateAndTime(new Date(seed.getTime() + 60 * 60000))
      : "",
    DurationMins: seed
      ? handleCalculateHowManyMinutesBetweenTwoDates(
          new Date(seed),
          new Date(seed.getTime() + 60 * 60000)
        )
      : 60,
    FlagAllDay: "0",
    taskchecklisttemplate_list: [],
    Vehicle_Id: "",
    // Task location (3-way): 0=inherit from linked Job, 1=site location, 2=manual address
    TaskLocationMode: 0,
    CustomerSiteLocation_Id: "",
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressLine4: "",
    AddressCity: "",
    AddressCounty: "",
    AddressPostCode: "",
    AddressCountry: "",
    LocationLatitude: "",
    LocationLongitude: "",
    LocationAddressLine1: "",
    LocationAddressLine2: "",
    LocationAddressLine3: "",
    LocationAddressLine4: "",
    LocationAddressCity: "",
    LocationAddressCounty: "",
    LocationAddressPostcode: "",
    LocationAddressCountry: "",
    Opportunity_Id: Opportunity_Id,
    taskTemplate: taskTemplate,
    DueDateTimeAddYears: "",
    DueDateTimeAddMonths: "",
    DueDateTimeAddDays: "",
    DueDateTimeAddHours: "",
    DueDateTimeAddMins: "",
    emailinbound_list: [
      {
        Id: singleEmail?.Id ?? "",
      },
    ],
  };
  const [singleTaskCreateUpdate, setsingleTaskCreateUpdate] =
    useState(initialTaskData);
  const [tempChecklistSelection, setTempChecklistSelection] = useState(null);
  console.log("singleTaskCreateUpdate", singleTaskCreateUpdate);
  useEffect(() => {
    dispatch(getStaffList());
    dispatch(getOrganisationDepartmentList());
    dispatch(getCustomersListData());
    dispatch(getTasksCrmITList());
    dispatch(getTaskStatusListCrmIT());
    dispatch(getTaskPriorityList());
    dispatch(getTaskTypeList());
    dispatch(getJobsData());
    dispatch(checkListTemplateListActive());
    dispatch(listVehicles());
    dispatch(getAllOpportunitiesList());
    dispatch(contactPersonList());
    if (!isEdit) {
      setsingleTaskCreateUpdate(initialTaskData);
    }
  }, []);
  // Fetch this customer's site locations for the location picker (mode 1).
  useEffect(() => {
    if (!singleTaskCreateUpdate?.Customer_Id) return;
    dispatch(
      getSingleCustomerSiteLocationListData([
        { customer_data: { Id: singleTaskCreateUpdate.Customer_Id } },
      ])
    );
  }, [singleTaskCreateUpdate?.Customer_Id]);
  useEffect(() => {
    if (isEmpty(jobsListApi)) return;
    let filteredJobsList = jobsListApi;

    if (singleTaskCreateUpdate?.Customer_Id) {
      filteredJobsList = filteredJobsList.filter(
        (job) => job.Customer_Id === singleTaskCreateUpdate?.Customer_Id
      );
    }

    setJobsList(filteredJobsList);
  }, [jobsListApi, singleTaskCreateUpdate?.Customer_Id]);

  // useEffect(() => {
  //   if (isEdit) return;
  //
  //   // check if singleTaskCreateUpdate === initialTaskData
  //   if (
  //     JSON.stringify(singleTaskCreateUpdate) ===
  //     JSON.stringify({ initialTaskData })
  //   )
  //     return;
  //
  //   setsingleTaskCreateUpdate(initialTaskData);
  //   return () => {
  //     setsingleTaskCreateUpdate(initialTaskData);
  //   };
  // }, []);

  useEffect(() => {
    // Whenever the modal opens and it is NOT in edit mode, wipe the slate clean
    if (modalTask && !isEdit) {
      setsingleTaskCreateUpdate(getInitialTaskData());
      setIsClearEditor(true);
      setTempChecklistSelection(null);
      setDiarySlotEnabled(false);
      setDiarySlot({
        StartDateTime: "",
        EndDateTime: "",
        Notes: "",
        AddressLine1: "",
        AddressLine2: "",
        AddressLine3: "",
        AddressLine4: "",
        AddressCity: "",
        AddressCounty: "",
        AddressPostcode: "",
      });
    }
  }, [modalTask, isEdit]);

  // Flush ALL local state once the modal has finished closing, so the next
  // open (create or edit) always starts from a clean slate. This covers every
  // close path — the X button, the Close button, the backdrop and ESC.
  const flushPopUpState = () => {
    setsingleTaskCreateUpdate(getInitialTaskData());
    setIsClearEditor(true);
    setTempChecklistSelection(null);
    setDiarySlotEnabled(false);
    setDiarySlot({
      StartDateTime: "",
      EndDateTime: "",
      Notes: "",
      AddressLine1: "",
      AddressLine2: "",
      AddressLine3: "",
      AddressLine4: "",
      AddressCity: "",
      AddressCounty: "",
      AddressPostcode: "",
    });
    setPopUpUpdateTask(false);
    setCreateTaskInProgress(false);
  };

  // Helper Functions to dispatch ai  to get new list updated data
  const handleHelperCustomerTaskList = () => {
    const TaskList = [
      {
        task_data: {
          Customer_Id,
        },
      },
    ];
    dispatch(searchTaskList(TaskList));
  };
  const handleHelperJobTaskList = () => {
    const TaskList = [
      {
        task_data: {
          Job_Id,
        },
      },
    ];
    dispatch(searchTaskList(TaskList));
    dispatch(getSingleJobRecentActivityList({ id: Job_Id }));
  };

  //helper

  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(taskCrmIT)) return;

    setsingleTaskCreateUpdate({
      Id: taskCrmIT?.Id,
      Title: taskCrmIT?.Title,
      Description: taskCrmIT?.Description,
      Customer_Id: taskCrmIT?.Customer_Id,
      ContactPerson_Id: taskCrmIT?.ContactPerson_Id,
      Staff_Id: taskCrmIT?.Staff_Id,
      OrganisationDepartment_Id: taskCrmIT?.OrganisationDepartment_Id ?? "",
      Project: taskCrmIT?.Project_Id,
      TaskType_Id: taskCrmIT?.TaskType_Id,
      TaskPriority_Id: taskCrmIT?.TaskPriority_Id,
      TaskStatus_Id: taskCrmIT?.TaskStatus_Id,
      Job_Id: taskCrmIT?.Job_Id,
      DueDateTime: taskCrmIT?.DueDateTime,
      StartDateTime: taskCrmIT?.StartDateTime,
      EndDateTime: taskCrmIT?.EndDateTime,
      FlagAllDay: taskCrmIT?.FlagAllDay,
      DurationMins: taskCrmIT?.DurationMins,
      taskchecklisttemplate_list: !isEmpty(taskCrmIT?.taskchecklist_list)
        ? taskCrmIT?.taskchecklist_list?.map((item, index) => ({
            Lid: index + 1,
            Id: item?.Id,
            TaskChecklistTemplate_Title: item?.Title,
            TaskChecklistTemplate_Id: item?.TaskChecklistTemplate_Id,
            isEdit: false,
          }))
        : [],
      Vehicle_Id: taskCrmIT?.Vehicle_Id,
      TaskLocationMode: taskCrmIT?.TaskLocationMode ?? 0,
      CustomerSiteLocation_Id: taskCrmIT?.CustomerSiteLocation_Id ?? "",
      AddressLine1: taskCrmIT?.AddressLine1 ?? "",
      AddressLine2: taskCrmIT?.AddressLine2 ?? "",
      AddressLine3: taskCrmIT?.AddressLine3 ?? "",
      AddressLine4: taskCrmIT?.AddressLine4 ?? "",
      AddressCity: taskCrmIT?.AddressCity ?? "",
      AddressCounty: taskCrmIT?.AddressCounty ?? "",
      AddressPostCode: taskCrmIT?.AddressPostCode ?? "",
      AddressCountry: taskCrmIT?.AddressCountry ?? "",
      LocationLatitude: taskCrmIT?.LocationLatitude,
      LocationLongitude: taskCrmIT?.LocationLongitude,
      LocationAddressLine1: taskCrmIT?.LocationAddressLine1,
      LocationAddressLine2: taskCrmIT?.LocationAddressLine2,
      LocationAddressLine3: taskCrmIT?.LocationAddressLine3,
      LocationAddressLine4: taskCrmIT?.LocationAddressLine4,
      LocationAddressCity: taskCrmIT?.LocationAddressCity,
      LocationAddressCounty: taskCrmIT?.LocationAddressCounty,
      LocationAddressPostcode: taskCrmIT?.LocationAddressPostcode,
      LocationAddressCountry: taskCrmIT?.LocationAddressCountry,
      Opportunity_Id: taskCrmIT?.Opportunity_Id,
      taskTemplate: taskCrmIT?.taskTemplate || false,
      DueDateTimeAddYears: taskCrmIT?.DueDateTimeAddYears,
      DueDateTimeAddMonths: taskCrmIT?.DueDateTimeAddMonths,
      DueDateTimeAddDays: taskCrmIT?.DueDateTimeAddDays,
      DueDateTimeAddHours: taskCrmIT?.DueDateTimeAddHours,
      DueDateTimeAddMins: taskCrmIT?.DueDateTimeAddMins,
      emailinbound_list: taskCrmIT?.emailinbound_list,
    });
  }, [taskCrmIT]);
  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(taskTemplateData)) return;

    setsingleTaskCreateUpdate({
      Id: taskTemplateData?.Id,
      Title: taskTemplateData?.Title,
      Description: taskTemplateData?.Description,
      Customer_Id: taskTemplateData?.Customer_Id,
      ContactPerson_Id: taskTemplateData?.ContactPerson_Id,
      Staff_Id: taskTemplateData?.Staff_Id,
      OrganisationDepartment_Id:
        taskTemplateData?.OrganisationDepartment_Id ?? "",
      Project: taskTemplateData?.Project_Id,
      TaskType_Id: taskTemplateData?.TaskType_Id,
      TaskPriority_Id: taskTemplateData?.TaskPriority_Id,
      TaskStatus_Id: taskTemplateData?.TaskStatus_Id,
      Job_Id: taskTemplateData?.Job_Id,
      DueDateTime: taskTemplateData?.DueDateTime,
      StartDateTime: taskTemplateData?.StartDateTime,
      EndDateTime: taskTemplateData?.EndDateTime,
      FlagAllDay: taskTemplateData?.FlagAllDay,
      DurationMins: taskTemplateData?.DurationMins,
      taskchecklisttemplate_list: !isEmpty(taskTemplateData?.taskchecklist_list)
        ? taskTemplateData?.taskchecklist_list?.map((item, index) => ({
            Lid: index + 1,
            Id: item?.Id,
            TaskChecklistTemplate_Title: item?.Title,
            TaskChecklistTemplate_Id: item?.TaskChecklistTemplate_Id,
            isEdit: false,
          }))
        : [],
      Vehicle_Id: taskTemplateData?.Vehicle_Id,
      TaskLocationMode: taskTemplateData?.TaskLocationMode ?? 0,
      CustomerSiteLocation_Id: taskTemplateData?.CustomerSiteLocation_Id ?? "",
      AddressLine1: taskTemplateData?.AddressLine1 ?? "",
      AddressLine2: taskTemplateData?.AddressLine2 ?? "",
      AddressLine3: taskTemplateData?.AddressLine3 ?? "",
      AddressLine4: taskTemplateData?.AddressLine4 ?? "",
      AddressCity: taskTemplateData?.AddressCity ?? "",
      AddressCounty: taskTemplateData?.AddressCounty ?? "",
      AddressPostCode: taskTemplateData?.AddressPostCode ?? "",
      AddressCountry: taskTemplateData?.AddressCountry ?? "",
      LocationLatitude: taskTemplateData?.LocationLatitude,
      LocationLongitude: taskTemplateData?.LocationLongitude,
      LocationAddressLine1: taskTemplateData?.LocationAddressLine1,
      LocationAddressLine2: taskTemplateData?.LocationAddressLine2,
      LocationAddressLine3: taskTemplateData?.LocationAddressLine3,
      LocationAddressLine4: taskTemplateData?.LocationAddressLine4,
      LocationAddressCity: taskTemplateData?.LocationAddressCity,
      LocationAddressCounty: taskTemplateData?.LocationAddressCounty,
      LocationAddressPostcode: taskTemplateData?.LocationAddressPostcode,
      LocationAddressCountry: taskTemplateData?.LocationAddressCountry,
      Opportunity_Id: taskTemplateData?.Opportunity_Id,
      taskTemplate: true,
      DueDateTimeAddYears: taskTemplateData?.DueDateTimeAddYears,
      DueDateTimeAddMonths: taskTemplateData?.DueDateTimeAddMonths,
      DueDateTimeAddDays: taskTemplateData?.DueDateTimeAddDays,
      DueDateTimeAddHours: taskTemplateData?.DueDateTimeAddHours,
      DueDateTimeAddMins: taskTemplateData?.DueDateTimeAddMins,
      emailinbound_list: taskTemplateData?.emailinbound_list,
    });
  }, [taskTemplateData]);

  // Handle Update Create Task
  const handleUpdateCreateTask = () => {
    const diaryslot_list =
      diarySlotEnabled && diarySlot.StartDateTime && diarySlot.EndDateTime
        ? [
            {
              StartDateTime: diarySlot.StartDateTime,
              EndDateTime: diarySlot.EndDateTime,
              Notes: diarySlot.Notes || "",
              AddressLine1: diarySlot.AddressLine1 || "",
              AddressLine2: diarySlot.AddressLine2 || "",
              AddressLine3: diarySlot.AddressLine3 || "",
              AddressLine4: diarySlot.AddressLine4 || "",
              AddressCity: diarySlot.AddressCity || "",
              AddressCounty: diarySlot.AddressCounty || "",
              AddressPostcode: diarySlot.AddressPostcode || "",
            },
          ]
        : [];
    const payload = { ...singleTaskCreateUpdate, diaryslot_list };

    if (isEdit) {
      payload.taskTemplate
        ? dispatch(updateTaskTemplate([payload]))
        : dispatch(updateTaskCrmIT([payload]));
      setPopUpUpdateTask(true);
    }
    if (!isEdit) {
      // Check if status selected
      if (!singleTaskCreateUpdate.TaskStatus_Id) {
        toast.error("Please select a Task Status");
        return;
      }
      // check if Title is empty
      if (!singleTaskCreateUpdate.Title) {
        toast.error("Please enter a Title");
        return;
      }
      // Task 24610 - kept for the create-success handler, which runs after the
      // form below has been reset.
      startTimerContextRef.current =
        startTimerOnSave && !payload.taskTemplate
          ? {
              Job_Id: payload?.Job_Id || Job_Id || "",
              Title: payload?.Title || "",
            }
          : null;

      payload.taskTemplate
        ? dispatch(createTaskTemplate([payload]))
        : dispatch(createTaskCrmIT([payload]));
      setCreateTaskInProgress(true);

      setsingleTaskCreateUpdate(initialTaskData);
      // Clear local state

      setIsClearEditor(true);
    }
    setLocalToggle(true);
  };
  const CallDispatchUpdateData = () => {
    dispatch(getTasksCrmITList());
    // Dispatch for Single Job tab
    if (Single_Job) {
      handleHelperJobTaskList();
    }
    // Dispatch for Single Customer tab
    if (Single_Customer) {
      handleHelperCustomerTaskList();
    }

    if (Single_Recent_Activity) {
      dispatch(getSingleJobRecentActivityList({ id: Job_Id }));
    }
    if (tasksCrmITList) {
      dispatch(getTasksCrmITList());
    }
    if (stopStartTimer) {
      dispatch(getSingleJobDetailsForTimer({ id: Job_Id }));
    }
    if (SingleTaskCrmIT && taskCrmIT.Id) {
      dispatch(
        getTaskCrmIT({
          id: taskCrmIT.Id,
        })
      );
    }
    if (!isEmpty(selectedWekStartAndEnd)) {
      if (!selectedWekStartAndEnd?.start || !selectedWekStartAndEnd?.end)
        return;
      dispatch(
        searchTaskList([
          {
            task_data: {
              StartDateTime: selectedWekStartAndEnd?.start,
              EndDateTime: selectedWekStartAndEnd?.end,
            },
          },
        ])
      );
    }
    if (Opportunity_Id) {
      dispatch(
        searchTaskList([
          {
            opportunity_data: { Id: Opportunity_Id },
          },
        ])
      );
    }
    setLocalToggle(true);
  };

  // Create Success
  const {
    createTaskSuccessAPI,
    taskCreateSuccessLoading,
    taskTemplateCreateSuccessAPI,
    taskTemplateCreateSuccessLoading,
  } = useSelector((state) => ({
    createTaskSuccessAPI: state.TasksCrmIt.taskCreateSuccess,
    taskCreateSuccessLoading: state.TasksCrmIt.taskCreateSuccessLoading,
    taskTemplateCreateSuccessAPI: state.TasksCrmIt.taskTemplateCreateSuccess,
    taskTemplateCreateSuccessLoading:
      state.TasksCrmIt.taskTemplateCreateSuccessLoading,
  }));

  //task
  useEffect(() => {
    if (isEmpty(createTaskSuccessAPI)) return;
    if (createTaskSuccessAPI.status === 200) {
      createTaskInProgress && toast.success(createTaskSuccessAPI.message);

      CallDispatchUpdateData();

      // Task 24610 / 24880 - the global timer is driven from redux, and there
      // are TWO outcomes depending on whether one is already running:
      //   nothing running -> put the task on the entry and flip timerIsRunning,
      //                      which TimeTrackingDropdown watches to OPEN an
      //                      entry server-side.
      //   already running -> move that entry onto the new task and raise
      //                      actionEventFired, which UPDATES the open entry.
      // They are deliberately different: restarting a running timer would close
      // the open entry and lose the time already on it.
      const timerContext = startTimerContextRef.current;
      startTimerContextRef.current = null;
      if (timerContext && createTaskSuccessAPI?.Task_Id) {
        if (timerRunning) {
          // Task 24880 - "when i already have a timer running it errors as i
          // want it to assign".
          //
          // A running timer must not be restarted: that would close the open
          // entry and lose the time already on it. Assigning instead just
          // points the entry that is ALREADY running at the new task.
          //
          // Writing timeentry_data then raising actionEventFired is the house
          // mechanism - TimeTrackingDropdown watches that flag and is the only
          // thing that PUTs the entry to the server (see its comment on Task
          // 24827). Without the flag this would change the screen and never
          // reach the database.
          dispatch(
            timeEntryReduxStateDataSuccess({
              timeentry_data: {
                ...(timerEntryData || {}),
                Job_Id: timerContext.Job_Id || timerEntryData?.Job_Id || "",
                Task_Id: createTaskSuccessAPI.Task_Id,
              },
            })
          );
          dispatch(actionEventFiredSuccess(true));
          toast.success(`Timer assigned to "${timerContext.Title}"`);
        } else {
          dispatch(
            timeEntryReduxStateDataSuccess({
              timeentry_data: {
                ...(timerEntryData || {}),
                Job_Id: timerContext.Job_Id || timerEntryData?.Job_Id || "",
                Task_Id: createTaskSuccessAPI.Task_Id,
              },
            })
          );
          dispatch(timerIsRunning(true));
          toast.success(`Timer started on "${timerContext.Title}"`);
        }
      }
      setStartTimerOnSave(false);

      setModalTask(false);

      setIsClearEditor(true);
      setsingleTaskCreateUpdate({ ...initialTaskData, Description: "" });
    } else {
      toast.error(createTaskSuccessAPI.message);
    }
    setCreateTaskInProgress(false);

    dispatch(createTaskCrmITSuccess([]));
    setLocalToggle(false);
  }, [createTaskSuccessAPI]);

  //template task create
  useEffect(() => {
    if (isEmpty(taskTemplateCreateSuccessAPI)) return;
    if (taskTemplateCreateSuccessAPI.status === 200) {
      createTaskInProgress &&
        toast.success(taskTemplateCreateSuccessAPI.message);
      dispatch(getTaskTemplateList());
      setModalTask(false);
    } else {
      toast.error(taskTemplateCreateSuccessAPI.message);
    }
    dispatch(createTaskTemplateSuccess([]));
  }, [taskTemplateCreateSuccessAPI]);

  // Update Success
  const {
    updateTaskSuccessAPI,
    taskUpdateSuccessLoading,
    taskTemplateUpdateSuccessAPI,
    taskTemplateUpdateSuccessLoading,
  } = useSelector((state) => ({
    updateTaskSuccessAPI: state.TasksCrmIt.taskUpdateSuccess,
    taskUpdateSuccessLoading: state.TasksCrmIt.taskUpdateSuccessLoading,
    taskTemplateUpdateSuccessAPI: state.TasksCrmIt.taskTemplateUpdateSuccess,
    taskTemplateUpdateSuccessLoading:
      state.TasksCrmIt.taskTemplateUpdateSuccessLoading,
  }));
  //task update
  useEffect(() => {
    const apiDataUpdate = updateTaskSuccessAPI;
    if (isEmpty(apiDataUpdate)) return;

    if (!popUpUpdateTask) return;

    if (apiDataUpdate.status === 200) {
      toast.success(apiDataUpdate.message);
      setModalTask(false);
      CallDispatchUpdateData();
      setPopUpUpdateTask(false);
      // dispatch only for Task List main page
    } else {
      toast.error(apiDataUpdate.message);
    }

    dispatch(updateTaskCrmITSuccess([]));
    setLocalToggle(false);
  }, [updateTaskSuccessAPI]);

  //template update
  useEffect(() => {
    if (isEmpty(taskTemplateUpdateSuccessAPI)) return;
    if (taskTemplateUpdateSuccessAPI.status === 200) {
      toast.success(taskTemplateUpdateSuccessAPI.message);
      setModalTask(false);
      dispatch(getTaskTemplateList());
    } else {
      toast.error(taskTemplateUpdateSuccessAPI.message);
      setModalTask(false);
    }
    dispatch(updateTaskTemplateSuccess([]));
  }, [taskTemplateUpdateSuccessAPI]);

  const CustomMenuAddNewJob = ({
    innerRef,
    innerProps,
    isDisabled,
    children,
  }) =>
    !isDisabled ? (
      <div
        ref={innerRef}
        {...innerProps}
        className="customReactSelectMenu"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          marginTop: "5px",
        }}
      >
        {children}
        <button
          className="btn btn-info btn-sm btn-block"
          onClick={() => {
            setModuleCreateJob(true);
          }}
        >
          Add New Job
        </button>
      </div>
    ) : null;
  const [moduleCreateJob, setModuleCreateJob] = useState(false);
  const toggleModuleCreateJob = () => setModuleCreateJob(!moduleCreateJob);

  const { PeopleListAPI, contactPersonListLoading } = useSelector((state) => ({
    PeopleListAPI: state.People.contactPersonList?.contactperson_list,
    contactPersonListLoading: state.People.contactPersonListLoading,
  }));

  console.log("PeopleListAPI", PeopleListAPI);
  return (
    <>
      {moduleCreateJob && (
        <JobCreateEdit
          modal={moduleCreateJob}
          setModal={setModuleCreateJob}
          toggle={toggleModuleCreateJob}
          isEdit={false}
        />
      )}
      <AppModal
        open={modalTask}
        onClose={toggleTask}
        title={
          isEdit
            ? (singleTaskCreateUpdate?.taskTemplate ? " Template: " : "") +
              "Edit Task # " +
              singleTaskCreateUpdate.Id
            : (singleTaskCreateUpdate?.taskTemplate ? " Template: " : "") +
              "Create New Task"
        }
        icon={<AssignmentOutlinedIcon />}
        headerAccent="indigo"
        size="md"
        loading={taskCreateSuccessLoading || taskUpdateSuccessLoading}
        loadingText={isEdit ? "Saving task…" : "Creating task…"}
        dialogProps={{ TransitionProps: { onExited: flushPopUpState } }}
        footer={
          <>
            <Button
              color="inherit"
              onClick={() =>
                setsingleTaskCreateUpdate({
                  ...singleTaskCreateUpdate,
                  taskTemplate: !singleTaskCreateUpdate?.taskTemplate,
                })
              }
            >
              <input
                className="me-2"
                type="checkbox"
                checked={singleTaskCreateUpdate?.taskTemplate || false}
                readOnly
              />{" "}
              Template
            </Button>
            {/* Task 24610 - only on create, and not for a template, which has
                nothing to time. */}
            {!isEdit && !singleTaskCreateUpdate?.taskTemplate && (
              <Button
                color="inherit"
                onClick={() => setStartTimerOnSave((v) => !v)}
                title={
                  timerRunning
                    ? "Your running timer will be moved onto this task when it is created. The time already on it is kept."
                    : "Start the timer on this task as soon as it is created"
                }
              >
                <input
                  className="me-2"
                  type="checkbox"
                  checked={startTimerOnSave}
                  readOnly
                />{" "}
                {/* Task 24880 - the label has to say which of the two things
                    will actually happen, because they are different actions:
                    starting a new timer vs. moving the running one. */}
                {timerRunning ? "Assign timer" : "Start timer"}
              </Button>
            )}
            <Button color="inherit" onClick={() => setModalTask(false)}>
              Close
            </Button>
            <Button
              variant="contained"
              color="success"
              disabled={taskCreateSuccessLoading || taskUpdateSuccessLoading}
              onClick={() => handleUpdateCreateTask()}
            >
              {!!isEdit ? "Update" : "Add Task"}
            </Button>
          </>
        }
      >
        <Input type="hidden" id="id-field" />
        <Row className="g-3">
          <Col lg={12}>
            <div>
              <Label htmlFor="name-field" className="form-label">
                Task Title
              </Label>

              <Input
                autoFocus={true}
                name="Title"
                id="Title"
                className="form-control"
                placeholder={
                  !!isEdit ? singleTaskCreateUpdate.Title : `Create Task Title`
                }
                type="text"
                validate={{
                  required: { value: true },
                }}
                onChange={(e) => {
                  setsingleTaskCreateUpdate({
                    ...singleTaskCreateUpdate,
                    Title: e.target.value,
                  });
                }}
                value={singleTaskCreateUpdate.Title || ""}
              />
            </div>
          </Col>
          <Col lg={12}>
            <div>
              <Label htmlFor="company_name-field" className="form-label">
                Task Description
              </Label>

              <RichTextEditor
                // Force a fresh editor instance every time the modal opens
                // and whenever the edited record changes, so no stale
                // Lexical state can ever leak across opens.
                key={`rte-${modalTask ? "open" : "closed"}-${
                  isEdit
                    ? singleTaskCreateUpdate?.taskTemplate
                      ? `tpl-${singleTaskCreateUpdate?.Id}`
                      : `task-${singleTaskCreateUpdate?.Id}`
                    : "new"
                }`}
                autoFocus={page === "singleEmailInbound"}
                initialValue={
                  isClearEditor ? "" : singleTaskCreateUpdate.Description
                }
                placeholder={
                  isEdit
                    ? singleTaskCreateUpdate.Description
                    : `Create Task Description`
                }
                handleContentChange={(e) => {
                  setsingleTaskCreateUpdate({
                    ...singleTaskCreateUpdate,
                    Description: e,
                  });
                }}
                // Only hydrate from existing data when editing. For a new
                // task this is always "" so the global taskCrmIT /
                // taskTemplateData (which still holds the previously opened
                // record) can never bleed into the description.
                receivedContent={
                  isClearEditor || !isEdit
                    ? ""
                    : (singleTaskCreateUpdate?.taskTemplate
                        ? taskTemplateData?.Description
                        : taskCrmIT?.Description) ?? ""
                }
                isClearEditor={isClearEditor}
                setIsClearEditor={setIsClearEditor}
              />
            </div>
          </Col>
          <Col lg={6}>
            <Label>Opportunities</Label>
            <Select
              isClearable={true}
              className="mb-0 job-select2"
              placeholder={"Select Opportunities"}
              value={
                singleTaskCreateUpdate.Opportunity_Id
                  ? {
                      label: Opportunities_List?.find(
                        (item) =>
                          item.Id === singleTaskCreateUpdate.Opportunity_Id
                      )?.Title,
                      value: singleTaskCreateUpdate.Opportunity_Id,
                      id: singleTaskCreateUpdate.Opportunity_Id,
                    }
                  : []
              }
              onChange={(e) => {
                setsingleTaskCreateUpdate({
                  ...singleTaskCreateUpdate,
                  Opportunity_Id: e?.id ?? "",
                });
              }}
              options={
                !isEmpty(Opportunities_List)
                  ? Opportunities_List?.map((item) => ({
                      label: item.Title,
                      value: item.Id,
                      id: item.Id,
                    }))
                  : []
              }
              id="country-select"
            ></Select>
          </Col>
          <Col lg={6}>
            <Label>Contact Person</Label>

            <CustomSelect
              value={
                singleTaskCreateUpdate?.ContactPerson_Id &&
                singleTaskCreateUpdate?.ContactPerson_Id +
                  " " +
                  PeopleListAPI?.find(
                    (item) =>
                      item.Id === singleTaskCreateUpdate?.ContactPerson_Id
                  )?.Title
              }
              placeholder={
                singleTaskCreateUpdate?.ContactPerson_Id
                  ? singleTaskCreateUpdate?.ContactPerson_Id +
                    " " +
                    PeopleListAPI?.find(
                      (item) =>
                        item.Id === singleTaskCreateUpdate?.ContactPerson_Id
                    )?.FullName
                  : "Select..."
              }
              onClickCallBack={(e) => {
                setsingleTaskCreateUpdate({
                  ...singleTaskCreateUpdate,
                  ContactPerson_Id: e?.id ?? "",
                });
              }}
              options={
                !isEmpty(PeopleListAPI)
                  ? PeopleListAPI?.map((item) => ({
                      firstLine: {
                        label: "#" + item?.Id + " " + item?.FullName,
                      },
                      secondLine: {
                        label:
                          item?.contactpersonemailaddress_list?.length > 0
                            ? "Email: " +
                              item?.contactpersonemailaddress_list
                                ?.map((email) => email?.EmailAddress)
                                .join(", ")
                            : "",
                      },
                      thirdLine: {
                        label:
                          item?.contactpersontelephonenumber_list?.length > 0
                            ? "Phone Nr: " +
                              item?.contactpersontelephonenumber_list
                                ?.map((email) => email?.TelephoneNumber)
                                .join(", ")
                            : "",
                      },
                      value: item?.Id,
                      id: item?.Id,
                      item,
                    }))
                  : []
              }
            />
          </Col>
          {!Single_Customer && (
            <Col lg={singleTaskCreateUpdate?.Customer_Id ? 4 : 6}>
              <div>
                <Label htmlFor="company_name-field" className="form-label">
                  Customer
                </Label>

                <div>
                  <Select
                    placeholder={"Select Customer"}
                    isClearable={true}
                    className="mb-0 job-select2"
                    value={
                      singleTaskCreateUpdate.Customer_Id
                        ? {
                            label: customersList?.find(
                              (item) =>
                                item.Id === singleTaskCreateUpdate.Customer_Id
                            )?.FullName,
                            value: singleTaskCreateUpdate.Customer_Id,
                            id: singleTaskCreateUpdate.Customer_Id,
                          }
                        : []
                    }
                    onChange={(e) => {
                      setsingleTaskCreateUpdate({
                        ...singleTaskCreateUpdate,
                        Customer_Id: e?.id ?? "",
                      });
                    }}
                    options={
                      !isEmpty(customersList)
                        ? customersList?.map((item) => ({
                            label: item.FullName,
                            value: item.Id,
                            id: item.Id,
                          }))
                        : []
                    }
                    id="country-select"
                  ></Select>
                </div>
              </div>
            </Col>
          )}
          {singleTaskCreateUpdate?.Customer_Id && (
            <Col lg={4}>
              <div>
                <Label htmlFor="company_name-field" className="form-label">
                  Job
                </Label>
                <div>
                  <Select
                    isClearable={true}
                    className="mb-0 job-select2"
                    placeholder={"Select Job"}
                    value={
                      singleTaskCreateUpdate.Job_Id
                        ? {
                            label: jobsList?.find(
                              (item) =>
                                item.Id === singleTaskCreateUpdate.Job_Id
                            )?.Title,
                            value: singleTaskCreateUpdate.Job_Id,
                            id: singleTaskCreateUpdate.Job_Id,
                          }
                        : []
                    }
                    onChange={(e) => {
                      setsingleTaskCreateUpdate({
                        ...singleTaskCreateUpdate,
                        Job_Id: e?.id ?? "",
                      });
                    }}
                    options={
                      !isEmpty(jobsList)
                        ? jobsList?.map((item) => ({
                            label: "#" + item?.Id + " " + item?.Title,
                            value: item?.Id,
                            id: item?.Id,
                          }))
                        : []
                    }
                    id="country-select"
                    // Opted out of AppSelect's body portal: this custom Menu is a
                    // plain in-flow div with no positioning of its own. See
                    // Common/AppSelect. TODO: rebuild as a portal-safe menu.
                    menuPortalTarget={null}
                    components={{ Menu: CustomMenuAddNewJob }}
                  ></Select>
                </div>
              </div>
            </Col>
          )}
          {singleTaskCreateUpdate?.Customer_Id && (
            <Col lg={12}>
              <div className="mb-2">
                <Label className="form-label d-block">Location</Label>
                <div className="btn-group mb-2" role="group">
                  {[
                    { mode: 0, label: "Inherit from Job" },
                    { mode: 1, label: "Site Location" },
                    { mode: 2, label: "Manual Address" },
                  ].map((opt) => (
                    <button
                      key={opt.mode}
                      type="button"
                      className={`btn btn-sm ${
                        Number(singleTaskCreateUpdate?.TaskLocationMode) ===
                        opt.mode
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => {
                        const mode = opt.mode;
                        // Modes are mutually exclusive: keep only the active
                        // mode's inputs so we never persist stale values.
                        setsingleTaskCreateUpdate({
                          ...singleTaskCreateUpdate,
                          TaskLocationMode: mode,
                          CustomerSiteLocation_Id:
                            mode === 1
                              ? singleTaskCreateUpdate?.CustomerSiteLocation_Id
                              : null,
                          AddressLine1:
                            mode === 2
                              ? singleTaskCreateUpdate?.AddressLine1
                              : "",
                          AddressLine2:
                            mode === 2
                              ? singleTaskCreateUpdate?.AddressLine2
                              : "",
                          AddressLine3:
                            mode === 2
                              ? singleTaskCreateUpdate?.AddressLine3
                              : "",
                          AddressLine4:
                            mode === 2
                              ? singleTaskCreateUpdate?.AddressLine4
                              : "",
                          AddressCity:
                            mode === 2
                              ? singleTaskCreateUpdate?.AddressCity
                              : "",
                          AddressCounty:
                            mode === 2
                              ? singleTaskCreateUpdate?.AddressCounty
                              : "",
                          AddressPostCode:
                            mode === 2
                              ? singleTaskCreateUpdate?.AddressPostCode
                              : "",
                          AddressCountry:
                            mode === 2
                              ? singleTaskCreateUpdate?.AddressCountry
                              : "",
                        });
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>

                {/* Mode 0: inherit from the linked Job (read-only preview) */}
                {Number(singleTaskCreateUpdate?.TaskLocationMode) === 0 && (
                  <div className="text-muted small">
                    {(() => {
                      if (!singleTaskCreateUpdate?.Job_Id)
                        return "No linked Job — this task will have no location.";
                      const job = jobsList?.find(
                        (j) => j.Id === singleTaskCreateUpdate?.Job_Id
                      );
                      const text = job ? getLocationSummaryText(job) : "";
                      return text
                        ? `Inheriting from Job: ${text}`
                        : "Linked Job has no location set.";
                    })()}
                  </div>
                )}

                {/* Mode 1: the task's own Site Location */}
                {Number(singleTaskCreateUpdate?.TaskLocationMode) === 1 && (
                  <CustomSelect
                    value={singleTaskCreateUpdate?.CustomerSiteLocation_Id}
                    placeholder={
                      singleTaskCreateUpdate?.CustomerSiteLocation_Id
                        ? "#" +
                          singleTaskCreateUpdate?.CustomerSiteLocation_Id +
                          (singleCustomerSiteLocationListAPI?.find(
                            (item) =>
                              item.Id ===
                              singleTaskCreateUpdate.CustomerSiteLocation_Id
                          )?.FullName
                            ? " " +
                              singleCustomerSiteLocationListAPI?.find(
                                (item) =>
                                  item.Id ===
                                  singleTaskCreateUpdate.CustomerSiteLocation_Id
                              )?.FullName
                            : "")
                        : "Select..."
                    }
                    onClickCallBack={(e) => {
                      setsingleTaskCreateUpdate({
                        ...singleTaskCreateUpdate,
                        CustomerSiteLocation_Id: e ? e?.value : null,
                      });
                    }}
                    options={
                      !isEmpty(singleCustomerSiteLocationListAPI)
                        ? singleCustomerSiteLocationListAPI?.map((item) => ({
                            firstLine: {
                              label:
                                "#" +
                                item?.Id +
                                " " +
                                item?.FullName +
                                (item?.SiteReference
                                  ? " " + item?.SiteReference
                                  : ""),
                            },
                            secondLine: {
                              label:
                                (item?.AddressLine1 || "") +
                                (item?.AddressCity
                                  ? " " + item?.AddressCity
                                  : "") +
                                (item?.AddressPostCode
                                  ? " " + item?.AddressPostCode
                                  : ""),
                            },
                            value: item?.Id,
                            id: item?.Id,
                            item,
                          }))
                        : []
                    }
                  />
                )}

                {/* Mode 2: manual typed address */}
                {Number(singleTaskCreateUpdate?.TaskLocationMode) === 2 && (
                  <div className="row">
                    {[
                      { key: "AddressLine1", label: "Address Line 1", col: 12 },
                      { key: "AddressLine2", label: "Address Line 2", col: 12 },
                      { key: "AddressLine3", label: "Address Line 3", col: 6 },
                      { key: "AddressLine4", label: "Address Line 4", col: 6 },
                      { key: "AddressCity", label: "City", col: 6 },
                      { key: "AddressCounty", label: "County", col: 6 },
                      { key: "AddressPostCode", label: "Post Code", col: 6 },
                      { key: "AddressCountry", label: "Country", col: 6 },
                    ].map((field) => (
                      <div
                        className={`col-lg-${field.col} mb-2`}
                        key={field.key}
                      >
                        <Label htmlFor={field.key} className="form-label">
                          {field.label}
                        </Label>
                        <Input
                          name={field.key}
                          id={field.key}
                          className="form-control"
                          type="text"
                          value={singleTaskCreateUpdate?.[field.key] ?? ""}
                          onChange={(e) => {
                            setsingleTaskCreateUpdate({
                              ...singleTaskCreateUpdate,
                              [field.key]: e.target.value,
                            });
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Col>
          )}
          <Col lg={singleTaskCreateUpdate?.Customer_Id ? 4 : 6}>
            <div>
              <Label htmlFor="company_name-field" className="form-label">
                Staff
              </Label>

              <div>
                <Select
                  isClearable={true}
                  className="mb-0 job-select2"
                  placeholder={"Select Staff"}
                  value={
                    singleTaskCreateUpdate.Staff_Id
                      ? {
                          label:
                            staffData?.find(
                              (item) =>
                                item.Id === singleTaskCreateUpdate.Staff_Id
                            )?.FirstName +
                            " " +
                            staffData?.find(
                              (item) =>
                                item.Id === singleTaskCreateUpdate.Staff_Id
                            )?.LastName,
                          value: singleTaskCreateUpdate.Staff_Id,
                          id: singleTaskCreateUpdate.Staff_Id,
                        }
                      : []
                  }
                  onChange={(e) => {
                    // if e empty set staff_Id ""
                    if (!e) {
                      setsingleTaskCreateUpdate({
                        ...singleTaskCreateUpdate,
                        Staff_Id: "",
                      });
                    } else {
                      setsingleTaskCreateUpdate({
                        ...singleTaskCreateUpdate,
                        Staff_Id: e?.id ?? "",
                      });
                    }
                  }}
                  options={
                    !isEmpty(staffData)
                      ? filterActiveStaff(staffData, [
                          singleTaskCreateUpdate.Staff_Id,
                        ])?.map((item) => ({
                          label: item?.FirstName + " " + item?.LastName,
                          value: item?.Id,
                          id: item?.Id,
                        }))
                      : []
                  }
                  id="country-select"
                ></Select>
              </div>
            </div>
          </Col>
          <Col lg={singleTaskCreateUpdate?.Customer_Id ? 4 : 6}>
            <div>
              <Label htmlFor="company_name-field" className="form-label">
                Team
              </Label>

              <div>
                <Select
                  isClearable={true}
                  className="mb-0 job-select2"
                  placeholder={"Assign to team"}
                  value={
                    singleTaskCreateUpdate.OrganisationDepartment_Id
                      ? {
                          label: organisationDepartmentList?.find(
                            (item) =>
                              item.Id ===
                              singleTaskCreateUpdate.OrganisationDepartment_Id
                          )?.Name,
                          value:
                            singleTaskCreateUpdate.OrganisationDepartment_Id,
                          id: singleTaskCreateUpdate.OrganisationDepartment_Id,
                        }
                      : []
                  }
                  onChange={(e) => {
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      OrganisationDepartment_Id: e?.id ?? "",
                    });
                  }}
                  options={
                    !isEmpty(organisationDepartmentList)
                      ? organisationDepartmentList?.map((item) => ({
                          label: item?.Name,
                          value: item?.Id,
                          id: item?.Id,
                        }))
                      : []
                  }
                  id="country-select"
                ></Select>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <Label htmlFor="company_name-field" className="form-label">
                Task Status
              </Label>

              <div>
                <Select
                  isClearable={true}
                  className="mb-0 job-select2"
                  placeholder={"Select Task Status"}
                  value={
                    singleTaskCreateUpdate.TaskStatus_Id
                      ? {
                          label: tasksCrmITStatusList?.find(
                            (item) =>
                              item.Id === singleTaskCreateUpdate.TaskStatus_Id
                          )?.Name,
                          value: singleTaskCreateUpdate.TaskStatus_Id,
                          id: singleTaskCreateUpdate.TaskStatus_Id,
                        }
                      : []
                  }
                  onChange={(e) => {
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      TaskStatus_Id: e?.id ?? "",
                    });
                  }}
                  options={
                    !isEmpty(tasksCrmITStatusList)
                      ? sortTaskStatuses(tasksCrmITStatusList).map((item) => ({
                          label: item.Name,
                          value: item.Id,
                          id: item.Id,
                        }))
                      : []
                  }
                  id="country-select"
                ></Select>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <Label htmlFor="company_name-field" className="form-label">
                Task Type
              </Label>

              <div>
                <Select
                  isClearable={true}
                  className="mb-0 job-select2"
                  placeholder={"Select Task Type"}
                  value={
                    singleTaskCreateUpdate.TaskType_Id
                      ? {
                          label: taskTypeList?.find(
                            (item) =>
                              item.Id === singleTaskCreateUpdate.TaskType_Id
                          )?.Name,
                          value: singleTaskCreateUpdate.TaskType_Id,
                          id: singleTaskCreateUpdate.TaskType_Id,
                        }
                      : []
                  }
                  onChange={(e) => {
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      TaskType_Id: e?.id ?? "",
                    });
                  }}
                  options={
                    !isEmpty(taskTypeList)
                      ? taskTypeList?.map((item) => ({
                          label: item?.Name,
                          value: item?.Id,
                          id: item?.Id,
                        }))
                      : []
                  }
                  id="country-select"
                ></Select>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <Label htmlFor="company_name-field" className="form-label">
                Task Priority
              </Label>

              <div>
                <Select
                  isClearable={true}
                  className="mb-0 job-select2"
                  placeholder={"Select Task Priority"}
                  value={
                    singleTaskCreateUpdate.TaskPriority_Id
                      ? {
                          label: taskPriorityList?.find(
                            (item) =>
                              item.Id === singleTaskCreateUpdate.TaskPriority_Id
                          )?.Name,
                          value: singleTaskCreateUpdate.TaskPriority_Id,
                          id: singleTaskCreateUpdate.TaskPriority_Id,
                        }
                      : []
                  }
                  onChange={(e) => {
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      TaskPriority_Id: e?.id ?? "",
                    });
                  }}
                  options={
                    !isEmpty(taskPriorityList)
                      ? taskPriorityList?.map((item) => ({
                          label: item?.Name,
                          value: item?.Id,
                          id: item?.Id,
                        }))
                      : []
                  }
                  id="country-select"
                ></Select>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <Label>Start</Label>
              <div className={"d-flex d-inline-flex w-100"}>
                <AppDateTimePicker
                  value={
                    singleTaskCreateUpdate.StartDateTime
                      ? moment(singleTaskCreateUpdate.StartDateTime)
                      : null
                  }
                  views={
                    singleTaskCreateUpdate?.FlagAllDay === "1"
                      ? ["year", "month", "day"]
                      : undefined
                  }
                  onChange={(val) => {
                    const jsDate = val && val.isValid() ? val.toDate() : null;
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      StartDateTime: jsDate
                        ? flatPickerConvertRawToFormatedDateAndTime(jsDate)
                        : "",
                      // recalculate duration
                      DurationMins:
                        singleTaskCreateUpdate.EndDateTime && jsDate
                          ? handleCalculateHowManyMinutesBetweenTwoDates(
                              new Date(jsDate),
                              new Date(singleTaskCreateUpdate.EndDateTime)
                            )
                          : 60,

                      EndDateTime: singleTaskCreateUpdate.EndDateTime
                        ? singleTaskCreateUpdate.EndDateTime
                        : jsDate
                        ? flatPickerConvertRawToFormatedDateAndTime([
                            new Date(
                              new Date(jsDate).setHours(
                                new Date(jsDate).getHours() + 1
                              )
                            ),
                          ])
                        : "",
                    });
                  }}
                  slotProps={{
                    textField: { placeholder: "Select Due date" },
                  }}
                />
                <button
                  onClick={() => {
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      StartDateTime: "",
                    });
                  }}
                  className={"btn btn-danger"}
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <Label>End</Label>
              <div className={"d-flex d-inline-flex w-100"}>
                <AppDateTimePicker
                  value={
                    singleTaskCreateUpdate.EndDateTime
                      ? moment(singleTaskCreateUpdate.EndDateTime)
                      : null
                  }
                  views={
                    singleTaskCreateUpdate?.FlagAllDay === "1"
                      ? ["year", "month", "day"]
                      : undefined
                  }
                  onChange={(val) => {
                    const jsDate = val && val.isValid() ? val.toDate() : null;
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      EndDateTime: jsDate
                        ? flatPickerConvertRawToFormatedDateAndTime(jsDate)
                        : "",
                      // recalculate duration
                      DurationMins:
                        singleTaskCreateUpdate.StartDateTime && jsDate
                          ? handleCalculateHowManyMinutesBetweenTwoDates(
                              new Date(singleTaskCreateUpdate.StartDateTime),
                              new Date(timeFormatDateAndTime(jsDate))
                            )
                          : null,
                    });
                  }}
                  slotProps={{
                    textField: { placeholder: "Select Due date" },
                  }}
                />
                <button
                  onClick={() => {
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      EndDateTime: "",
                    });
                  }}
                  className={"btn btn-danger"}
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
          </Col>
          {singleTaskCreateUpdate?.FlagAllDay === "0" && (
            <Col lg={3}>
              <div>
                <Label>Duration</Label>
                <div className={"d-flex d-inline-flex w-100"}>
                  <div className={"d-flex flex-row align-items-center"}>
                    <div className={"d-flex flex-row align-items-center"}>
                      <input
                        className={"time-duration-input"}
                        type={"number"}
                        placeholder={"Hrs.."}
                        value={
                          // convert min to hours and keep hours only
                          Math.floor(
                            singleTaskCreateUpdate.DurationMins / 60
                          ) ?? 0
                        }
                        onChange={(e) => {
                          handleOnChangeHoursInput(
                            e,
                            singleTaskCreateUpdate,
                            setsingleTaskCreateUpdate
                          );
                        }}
                      />
                    </div>
                    <div className={"time-up-and-down-cursor-block"}>
                      <span
                        title={"+1 Hour"}
                        className={"cursor-pointer"}
                        onClick={() => {
                          handleIncreaseDecraeseDurationByHourOrByMinutes(
                            -1,
                            0,
                            singleTaskCreateUpdate,
                            setsingleTaskCreateUpdate
                          );
                        }}
                      >
                        <i className="fa-solid fa-caret-up"></i>
                      </span>
                      <span
                        title={"-1 Hour"}
                        onClick={() => {
                          handleIncreaseDecraeseDurationByHourOrByMinutes(
                            1,
                            0,
                            singleTaskCreateUpdate,
                            setsingleTaskCreateUpdate
                          );
                        }}
                        className={"cursor-pointer"}
                      >
                        <i className="fa-solid fa-caret-down"></i>
                      </span>
                    </div>
                    <div>
                      <span className={"fs-24 fw-bold mx-2"}>:</span>
                    </div>
                    <div className={"d-flex flex-row align-items-center  "}>
                      <input
                        className={"time-duration-input"}
                        type={"number"}
                        placeholder={"Mins.."}
                        value={
                          // convert min to hours and keep hours only
                          singleTaskCreateUpdate.DurationMins % 60 ?? 0
                        }
                        onChange={(e) => {
                          handleOnChangeMinutesInput(
                            e,
                            singleTaskCreateUpdate,
                            setsingleTaskCreateUpdate
                          );
                        }}
                      />{" "}
                    </div>
                    <div className={"time-up-and-down-cursor-block"}>
                      <span
                        title={"+1 Min"}
                        className={"cursor-pointer"}
                        onClick={() => {
                          handleIncreaseDecraeseDurationByHourOrByMinutes(
                            0,
                            -1,
                            singleTaskCreateUpdate,
                            setsingleTaskCreateUpdate
                          );
                        }}
                      >
                        <i className="fa-solid fa-caret-up"></i>
                      </span>
                      <span
                        title={"-1 Min"}
                        className={"cursor-pointer"}
                        onClick={() => {
                          handleIncreaseDecraeseDurationByHourOrByMinutes(
                            0,
                            1,
                            singleTaskCreateUpdate,
                            setsingleTaskCreateUpdate
                          );
                        }}
                      >
                        <i className="fa-solid fa-caret-down"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )}

          <Col
            lg={singleTaskCreateUpdate?.FlagAllDay === "1" ? 4 : 1}
            className={"text-end"}
          >
            <Label>All Day</Label>
            <div
              className={"d-flex justify-content-end "}
              style={{ marginTop: "10px" }}
            >
              <input
                type="checkbox"
                className=" form-check-input  "
                checked={singleTaskCreateUpdate.FlagAllDay === "1"}
                onChange={(e) => {
                  setsingleTaskCreateUpdate({
                    ...singleTaskCreateUpdate,
                    FlagAllDay: e.target.checked ? "1" : "0",
                  });
                }}
              />
            </div>
          </Col>
          {isSystemModuleActive(SYSTEM_MODULE_CODES.CUSTOMER_VEHICLE) && (
            <Col lg={12}>
              <Label>Select Vehicle</Label>
              <Select
                isClearable={true}
                placeholder={"Select Vehicle"}
                value={
                  singleTaskCreateUpdate?.Vehicle_Id
                    ? {
                        label:
                          "#" +
                          singleTaskCreateUpdate?.Vehicle_Id +
                          " " +
                          (vehicleListAPI?.find(
                            (item) =>
                              item.Id === singleTaskCreateUpdate.Vehicle_Id
                          )?.RegistrationPlate
                            ? "Reg: " +
                              vehicleListAPI?.find(
                                (item) =>
                                  item.Id === singleTaskCreateUpdate.Vehicle_Id
                              )?.RegistrationPlate
                            : "") +
                          " " +
                          (vehicleListAPI?.find(
                            (item) =>
                              item.Id === singleTaskCreateUpdate.Vehicle_Id
                          )?.MinistryId
                            ? "[MinstrId: " +
                              vehicleListAPI?.find(
                                (item) =>
                                  item.Id === singleTaskCreateUpdate.Vehicle_Id
                              )?.MinistryId +
                              " ]"
                            : ""),
                        value: singleTaskCreateUpdate.Vehicle_Id,
                        id: singleTaskCreateUpdate.Vehicle_Id,
                      }
                    : []
                }
                options={
                  !isEmpty(vehicleListAPI)
                    ? vehicleListAPI?.map((item) => ({
                        label:
                          "#" +
                          item?.Id +
                          " " +
                          (item?.RegistrationPlate
                            ? "Reg: " + item?.RegistrationPlate
                            : "") +
                          " " +
                          (item?.MinistryId
                            ? "[MinstrId: " + item?.MinistryId + " ]"
                            : ""),

                        value: item?.Id,
                        id: item?.Id,
                      }))
                    : []
                }
                onChange={(e) => {
                  setsingleTaskCreateUpdate({
                    ...singleTaskCreateUpdate,
                    Vehicle_Id: e?.value ?? "",
                  });
                }}
              ></Select>
            </Col>
          )}
          <Col lg={12}>
            <Label>Select Checklist</Label>
            <Row>
              <Col lg={9}>
                {" "}
                <Select
                  style={{ width: "70%" }}
                  placeholder="Select Checklist"
                  isClearable={true}
                  className="mb-0 "
                  value={tempChecklistSelection ? tempChecklistSelection : null}
                  onChange={(e) => {
                    //if e is null then set null otherwise set e.id
                    setTempChecklistSelection(e ? e : null);
                  }}
                  options={
                    !isEmpty(checklistTemplateActiveAPI)
                      ? checklistTemplateActiveAPI?.map((item) => ({
                          label: item?.Title,
                          value: item?.Id,
                          id: item?.Id,
                        }))
                      : []
                  }
                ></Select>
              </Col>
              <Col lg={3}>
                <button
                  className={"btn btn-success w-100"}
                  onClick={() => {
                    handleAddNewItemToCheckList(
                      tempChecklistSelection,
                      singleTaskCreateUpdate,
                      setsingleTaskCreateUpdate
                    );
                  }}
                >
                  Add Checklist
                </button>
              </Col>
            </Row>
            {!isEmpty(singleTaskCreateUpdate?.taskchecklisttemplate_list) && (
              <Row className={"mt-4"}>
                {singleTaskCreateUpdate?.taskchecklisttemplate_list?.map(
                  (checklist, index) => (
                    <Col
                      lg={4}
                      key={checklist?.TaskChecklistTemplate_Id + index}
                    >
                      <Card className={"p-2"}>
                        <div className={"d-flex justify-content-between  "}>
                          <div>
                            {checklist?.isEdit ? (
                              <Input
                                autoFocus={true}
                                name="Title"
                                id="Title"
                                className="form-control"
                                placeholder={
                                  !!isEdit
                                    ? checklist?.TaskChecklistTemplate_Title
                                    : `Create Task Title`
                                }
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={(e) => {
                                  // only change selected checklist title
                                  setsingleTaskCreateUpdate({
                                    ...singleTaskCreateUpdate,
                                    taskchecklisttemplate_list:
                                      singleTaskCreateUpdate?.taskchecklisttemplate_list.map(
                                        (item) =>
                                          item?.Lid === checklist?.Lid
                                            ? {
                                                ...item,
                                                TaskChecklistTemplate_Title:
                                                  e.target.value,
                                              }
                                            : item
                                      ),
                                  });
                                }}
                                value={
                                  checklist?.TaskChecklistTemplate_Title || ""
                                }
                                onBlur={() => {
                                  // on blur set isEdit to false
                                  setsingleTaskCreateUpdate({
                                    ...singleTaskCreateUpdate,
                                    taskchecklisttemplate_list:
                                      singleTaskCreateUpdate?.taskchecklisttemplate_list.map(
                                        (item) =>
                                          item?.TaskChecklistTemplate_Id ===
                                          checklist?.TaskChecklistTemplate_Id
                                            ? {
                                                ...item,
                                                isEdit: false,
                                              }
                                            : item
                                      ),
                                  });
                                }}
                                // on enter same
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    setsingleTaskCreateUpdate({
                                      ...singleTaskCreateUpdate,
                                      taskchecklisttemplate_list:
                                        singleTaskCreateUpdate?.taskchecklisttemplate_list.map(
                                          (item) =>
                                            item?.TaskChecklistTemplate_Id ===
                                            checklist?.TaskChecklistTemplate_Id
                                              ? {
                                                  ...item,
                                                  isEdit: false,
                                                }
                                              : item
                                        ),
                                    });
                                  }
                                }}
                              />
                            ) : (
                              <div>
                                {checklist?.TaskChecklistTemplate_Title}
                              </div>
                            )}
                          </div>
                          <div>
                            <div>
                              <button
                                onClick={() => {
                                  setsingleTaskCreateUpdate({
                                    ...singleTaskCreateUpdate,
                                    taskchecklisttemplate_list:
                                      singleTaskCreateUpdate?.taskchecklisttemplate_list.filter(
                                        (item) => item?.Lid !== checklist?.Lid
                                      ),
                                  });
                                }}
                                className={"btn btn-sm btn-soft-danger"}
                              >
                                <i className="fa-regular fa-square-minus"></i>
                              </button>
                            </div>
                            <div>
                              <button
                                onClick={() => {
                                  // toggle isEdit
                                  setsingleTaskCreateUpdate({
                                    ...singleTaskCreateUpdate,
                                    taskchecklisttemplate_list:
                                      singleTaskCreateUpdate?.taskchecklisttemplate_list.map(
                                        (item) =>
                                          item?.Lid === checklist?.Lid
                                            ? {
                                                ...item,
                                                isEdit: !item?.isEdit,
                                              }
                                            : item
                                      ),
                                  });
                                }}
                                className={"btn btn-sm btn-soft-warning"}
                              >
                                <i className="fa-regular fa-pen-to-square"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </Card>
                    </Col>
                  )
                )}
                <hr />
              </Row>
            )}
          </Col>
          <Col lg={12}>
            <SearchAddress
              taskData={singleTaskCreateUpdate}
              setTaskData={setsingleTaskCreateUpdate}
            />
          </Col>

          {/* Field Diary Slot — collapsible */}
          <Col lg={12}>
            <button
              type="button"
              className="btn btn-soft-info w-100 d-flex align-items-center justify-content-between"
              style={{ borderRadius: 8 }}
              onClick={() => setDiarySlotEnabled((v) => !v)}
            >
              <span className="d-flex align-items-center gap-2">
                <i className="ri-calendar-schedule-line fs-15" />
                <span className="fw-semibold">Field Diary Slot</span>
                {diarySlotEnabled &&
                  diarySlot.StartDateTime &&
                  diarySlot.EndDateTime && (
                    <span
                      className="badge bg-info ms-1"
                      style={{ fontSize: 10 }}
                    >
                      {diarySlot.StartDateTime.slice(11, 16)} –{" "}
                      {diarySlot.EndDateTime.slice(11, 16)}
                    </span>
                  )}
              </span>
              <i
                className={`ri-arrow-${
                  diarySlotEnabled ? "up" : "down"
                }-s-line fs-16`}
              />
            </button>

            {diarySlotEnabled && (
              <div
                className="mt-2 p-3 border rounded"
                style={{ background: "#f8fafc", borderColor: "#cfe2ff" }}
              >
                <Row className="g-3">
                  <Col lg={6}>
                    <Label className="form-label">Slot Start</Label>
                    <div className="d-flex d-inline-flex w-100">
                      <AppDateTimePicker
                        value={
                          diarySlot.StartDateTime
                            ? moment(diarySlot.StartDateTime)
                            : null
                        }
                        slotProps={{
                          textField: {
                            placeholder: "Select start date & time",
                          },
                        }}
                        onChange={(val) => {
                          const jsDate =
                            val && val.isValid() ? val.toDate() : null;
                          if (!jsDate) return;
                          const start = jsDate;
                          const startStr =
                            start.getFullYear() +
                            "-" +
                            String(start.getMonth() + 1).padStart(2, "0") +
                            "-" +
                            String(start.getDate()).padStart(2, "0") +
                            " " +
                            String(start.getHours()).padStart(2, "0") +
                            ":" +
                            String(start.getMinutes()).padStart(2, "0") +
                            ":00";
                          // auto-set end to start + 1h if end not set yet
                          const autoEnd = new Date(
                            start.getTime() + 60 * 60000
                          );
                          const endStr =
                            autoEnd.getFullYear() +
                            "-" +
                            String(autoEnd.getMonth() + 1).padStart(2, "0") +
                            "-" +
                            String(autoEnd.getDate()).padStart(2, "0") +
                            " " +
                            String(autoEnd.getHours()).padStart(2, "0") +
                            ":" +
                            String(autoEnd.getMinutes()).padStart(2, "0") +
                            ":00";
                          setDiarySlot((prev) => ({
                            ...prev,
                            StartDateTime: startStr,
                            EndDateTime: prev.EndDateTime || endStr,
                          }));
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() =>
                          setDiarySlot((prev) => ({
                            ...prev,
                            StartDateTime: "",
                          }))
                        }
                      >
                        <i className="fa-solid fa-xmark" />
                      </button>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <Label className="form-label">Slot End</Label>
                    <div className="d-flex d-inline-flex w-100">
                      <AppDateTimePicker
                        value={
                          diarySlot.EndDateTime
                            ? moment(diarySlot.EndDateTime)
                            : null
                        }
                        slotProps={{
                          textField: { placeholder: "Select end date & time" },
                        }}
                        onChange={(val) => {
                          const jsDate =
                            val && val.isValid() ? val.toDate() : null;
                          if (!jsDate) return;
                          const end = jsDate;
                          const endStr =
                            end.getFullYear() +
                            "-" +
                            String(end.getMonth() + 1).padStart(2, "0") +
                            "-" +
                            String(end.getDate()).padStart(2, "0") +
                            " " +
                            String(end.getHours()).padStart(2, "0") +
                            ":" +
                            String(end.getMinutes()).padStart(2, "0") +
                            ":00";
                          setDiarySlot((prev) => ({
                            ...prev,
                            EndDateTime: endStr,
                          }));
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() =>
                          setDiarySlot((prev) => ({ ...prev, EndDateTime: "" }))
                        }
                      >
                        <i className="fa-solid fa-xmark" />
                      </button>
                    </div>
                  </Col>

                  <Col lg={12}>
                    <Label className="form-label">Slot Notes</Label>
                    <Input
                      type="textarea"
                      rows={2}
                      placeholder="Optional notes for this diary slot…"
                      value={diarySlot.Notes}
                      onChange={(e) =>
                        setDiarySlot((prev) => ({
                          ...prev,
                          Notes: e.target.value,
                        }))
                      }
                    />
                  </Col>

                  <Col lg={12}>
                    <Label className="form-label mb-1 d-flex align-items-center gap-1">
                      <i className="ri-map-pin-line" /> Slot Address
                    </Label>
                  </Col>
                  <Col lg={6}>
                    <Input
                      placeholder="Address Line 1"
                      value={diarySlot.AddressLine1}
                      onChange={(e) =>
                        setDiarySlot((prev) => ({
                          ...prev,
                          AddressLine1: e.target.value,
                        }))
                      }
                    />
                  </Col>
                  <Col lg={6}>
                    <Input
                      placeholder="Address Line 2"
                      value={diarySlot.AddressLine2}
                      onChange={(e) =>
                        setDiarySlot((prev) => ({
                          ...prev,
                          AddressLine2: e.target.value,
                        }))
                      }
                    />
                  </Col>
                  <Col lg={6}>
                    <Input
                      placeholder="Address Line 3"
                      value={diarySlot.AddressLine3}
                      onChange={(e) =>
                        setDiarySlot((prev) => ({
                          ...prev,
                          AddressLine3: e.target.value,
                        }))
                      }
                    />
                  </Col>
                  <Col lg={6}>
                    <Input
                      placeholder="Address Line 4"
                      value={diarySlot.AddressLine4}
                      onChange={(e) =>
                        setDiarySlot((prev) => ({
                          ...prev,
                          AddressLine4: e.target.value,
                        }))
                      }
                    />
                  </Col>
                  <Col lg={4}>
                    <Input
                      placeholder="City"
                      value={diarySlot.AddressCity}
                      onChange={(e) =>
                        setDiarySlot((prev) => ({
                          ...prev,
                          AddressCity: e.target.value,
                        }))
                      }
                    />
                  </Col>
                  <Col lg={4}>
                    <Input
                      placeholder="County"
                      value={diarySlot.AddressCounty}
                      onChange={(e) =>
                        setDiarySlot((prev) => ({
                          ...prev,
                          AddressCounty: e.target.value,
                        }))
                      }
                    />
                  </Col>
                  <Col lg={4}>
                    <Input
                      placeholder="Postcode"
                      value={diarySlot.AddressPostcode}
                      onChange={(e) =>
                        setDiarySlot((prev) => ({
                          ...prev,
                          AddressPostcode: e.target.value,
                        }))
                      }
                    />
                  </Col>
                </Row>
              </div>
            )}
          </Col>

          {/* as long as its not a template*/}
          {!singleTaskCreateUpdate?.taskTemplate && (
            <Col lg={12}>
              <div>
                <Label htmlFor="company_name-field" className="form-label">
                  Due Date
                </Label>

                <div>
                  <div className={"d-flex d-inline-flex w-100"}>
                    <AppDateTimePicker
                      value={
                        singleTaskCreateUpdate.DueDateTime
                          ? moment(singleTaskCreateUpdate.DueDateTime)
                          : null
                      }
                      onChange={(val) => {
                        const jsDate =
                          val && val.isValid() ? val.toDate() : null;
                        setsingleTaskCreateUpdate({
                          ...singleTaskCreateUpdate,
                          DueDateTime: jsDate
                            ? flatPickerConvertRawToFormatedDateAndTime(jsDate)
                            : "",
                        });
                      }}
                      slotProps={{
                        textField: { placeholder: "Select Due date" },
                      }}
                    />
                    <button
                      onClick={() => {
                        setsingleTaskCreateUpdate({
                          ...singleTaskCreateUpdate,
                          DueDateTime: "",
                        });
                      }}
                      className={"btn btn-danger"}
                    >
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                  <div className={"pt-2 d-flex justify-content-center"}>
                    <div className={"p-2"}>
                      <button
                        className={"btn btn-soft-success"}
                        onClick={() => {
                          setsingleTaskCreateUpdate({
                            ...singleTaskCreateUpdate,
                            // Today
                            DueDateTime:
                              flatPickerConvertRawToFormatedDateAndTime([
                                new Date(),
                              ]),
                          });
                        }}
                      >
                        Today
                      </button>
                    </div>
                    <div className={"p-2"}>
                      <button
                        onClick={() => {
                          setsingleTaskCreateUpdate({
                            ...singleTaskCreateUpdate,
                            // Tomorrow + 1 day
                            DueDateTime:
                              flatPickerConvertRawToFormatedDateAndTime([
                                new Date(
                                  new Date().setDate(new Date().getDate() + 1)
                                ),
                              ]),
                          });
                        }}
                        className={"btn btn-soft-info"}
                      >
                        Tomorrow
                      </button>
                    </div>
                    <div className={"p-2"}>
                      <button
                        onClick={() => {
                          setsingleTaskCreateUpdate({
                            ...singleTaskCreateUpdate,
                            // + 1 Week
                            DueDateTime:
                              flatPickerConvertRawToFormatedDateAndTime([
                                new Date(
                                  new Date().setDate(new Date().getDate() + 7)
                                ),
                              ]),
                          });
                        }}
                        className={"btn btn-soft-primary"}
                      >
                        1 Week
                      </button>
                    </div>
                    <div className={"p-2"}>
                      <button
                        onClick={() => {
                          setsingleTaskCreateUpdate({
                            ...singleTaskCreateUpdate,
                            // add exactly + 1 month to current date if current date is 31st of any month then it will add 1 month and 1 day
                            DueDateTime:
                              flatPickerConvertRawToFormatedDateAndTime([
                                new Date(
                                  new Date().setMonth(new Date().getMonth() + 1)
                                ),
                              ]),
                          });
                        }}
                        className={"btn btn-soft-secondary"}
                      >
                        1 Month
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )}
        </Row>
        {singleTaskCreateUpdate?.taskTemplate && (
          <Row className="g-3 mt-2">
            <Col lg={12}>
              <Label className="form-label mb-1">
                Due date offset (Template)
              </Label>
              <div className="text-muted small mb-2">
                When a task is created from this template, the Due Date =
                <strong> Start</strong> + the offset below.
              </div>
            </Col>

            {/* Inputs: Years / Months / Days / Hours / Minutes */}
            <Col lg={2} md={4} sm={6}>
              <Label className="form-label">Years</Label>
              <Input
                type="number"
                min={0}
                placeholder="0"
                value={singleTaskCreateUpdate?.DueDateTimeAddYears ?? ""}
                onChange={(e) =>
                  setsingleTaskCreateUpdate({
                    ...singleTaskCreateUpdate,
                    DueDateTimeAddYears:
                      e.target.value === ""
                        ? ""
                        : Math.max(0, Number(e.target.value)),
                  })
                }
              />
            </Col>
            <Col lg={2} md={4} sm={6}>
              <Label className="form-label">Months</Label>
              <Input
                type="number"
                min={0}
                placeholder="0"
                value={singleTaskCreateUpdate?.DueDateTimeAddMonths ?? ""}
                onChange={(e) =>
                  setsingleTaskCreateUpdate({
                    ...singleTaskCreateUpdate,
                    DueDateTimeAddMonths:
                      e.target.value === ""
                        ? ""
                        : Math.max(0, Number(e.target.value)),
                  })
                }
              />
            </Col>
            <Col lg={2} md={4} sm={6}>
              <Label className="form-label">Days</Label>
              <Input
                type="number"
                min={0}
                placeholder="0"
                value={singleTaskCreateUpdate?.DueDateTimeAddDays ?? ""}
                onChange={(e) =>
                  setsingleTaskCreateUpdate({
                    ...singleTaskCreateUpdate,
                    DueDateTimeAddDays:
                      e.target.value === ""
                        ? ""
                        : Math.max(0, Number(e.target.value)),
                  })
                }
              />
            </Col>
            <Col lg={2} md={4} sm={6}>
              <Label className="form-label">Hours</Label>
              <Input
                type="number"
                min={0}
                max={23}
                placeholder="0"
                value={singleTaskCreateUpdate?.DueDateTimeAddHours ?? ""}
                onChange={(e) => {
                  const raw = e.target.value;
                  if (raw === "") {
                    return setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      DueDateTimeAddHours: "",
                    });
                  }
                  const v = Number(raw);
                  if (v < 0 || v > 23) return toast.error("Hours must be 0–23");
                  setsingleTaskCreateUpdate({
                    ...singleTaskCreateUpdate,
                    DueDateTimeAddHours: v,
                  });
                }}
              />
            </Col>
            <Col lg={2} md={4} sm={6}>
              <Label className="form-label">Minutes</Label>
              <Input
                type="number"
                min={0}
                max={59}
                placeholder="0"
                value={singleTaskCreateUpdate?.DueDateTimeAddMins ?? ""}
                onChange={(e) => {
                  const raw = e.target.value;
                  if (raw === "") {
                    return setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      DueDateTimeAddMins: "",
                    });
                  }
                  const v = Number(raw);
                  if (v < 0 || v > 59)
                    return toast.error("Minutes must be 0–59");
                  setsingleTaskCreateUpdate({
                    ...singleTaskCreateUpdate,
                    DueDateTimeAddMins: v,
                  });
                }}
              />
            </Col>

            {/* Quick presets */}
            <Col lg={12}>
              <div className="d-flex flex-wrap gap-2 mt-1">
                <button
                  type="button"
                  className="btn btn-soft-secondary btn-sm"
                  onClick={() =>
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      DueDateTimeAddYears: "",
                      DueDateTimeAddMonths: "",
                      DueDateTimeAddDays: 1,
                      DueDateTimeAddHours: "",
                      DueDateTimeAddMins: "",
                    })
                  }
                >
                  +1 Day
                </button>

                <button
                  type="button"
                  className="btn btn-soft-secondary btn-sm"
                  onClick={() =>
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      DueDateTimeAddYears: "",
                      DueDateTimeAddMonths: "",
                      DueDateTimeAddDays: 7,
                      DueDateTimeAddHours: "",
                      DueDateTimeAddMins: "",
                    })
                  }
                >
                  +7 Days (1 Week)
                </button>

                <button
                  type="button"
                  className="btn btn-soft-secondary btn-sm"
                  onClick={() =>
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      DueDateTimeAddYears: "",
                      DueDateTimeAddMonths: 1,
                      DueDateTimeAddDays: "",
                      DueDateTimeAddHours: "",
                      DueDateTimeAddMins: "",
                    })
                  }
                >
                  +1 Month
                </button>

                <button
                  type="button"
                  className="btn btn-soft-secondary btn-sm"
                  onClick={() =>
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      DueDateTimeAddYears: "",
                      DueDateTimeAddMonths: 6,
                      DueDateTimeAddDays: "",
                      DueDateTimeAddHours: "",
                      DueDateTimeAddMins: "",
                    })
                  }
                >
                  +6 Months
                </button>

                <button
                  type="button"
                  className="btn btn-soft-secondary btn-sm"
                  onClick={() =>
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      DueDateTimeAddYears: 1,
                      DueDateTimeAddMonths: "",
                      DueDateTimeAddDays: "",
                      DueDateTimeAddHours: "",
                      DueDateTimeAddMins: "",
                    })
                  }
                >
                  +1 Year
                </button>

                <button
                  type="button"
                  className="btn btn-soft-danger btn-sm"
                  onClick={() =>
                    setsingleTaskCreateUpdate({
                      ...singleTaskCreateUpdate,
                      DueDateTimeAddYears: "",
                      DueDateTimeAddMonths: "",
                      DueDateTimeAddDays: "",
                      DueDateTimeAddHours: "",
                      DueDateTimeAddMins: "",
                    })
                  }
                >
                  Clear
                </button>
              </div>
            </Col>

            {/* Live preview (approximate) */}
            <Col lg={12}>
              <div className="mt-2 p-2 bg-light rounded border">
                <div className="small text-muted">Offset preview</div>
                <div className="fw-semibold">
                  {(() => {
                    const y = Number(
                      singleTaskCreateUpdate?.DueDateTimeAddYears || 0
                    );
                    const m = Number(
                      singleTaskCreateUpdate?.DueDateTimeAddMonths || 0
                    );
                    const d = Number(
                      singleTaskCreateUpdate?.DueDateTimeAddDays || 0
                    );
                    const h = Number(
                      singleTaskCreateUpdate?.DueDateTimeAddHours || 0
                    );
                    const min = Number(
                      singleTaskCreateUpdate?.DueDateTimeAddMins || 0
                    );

                    return `${y}y ${m}m ${d}d ${h}h ${min}m`;
                  })()}
                </div>
              </div>
            </Col>
          </Row>
        )}
      </AppModal>
    </>
  );
}
